import React, { createContext, useState, useCallback, useContext } from "react";

const ToolBarContext = createContext();

export const ToolBarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  return (
    <ToolBarContext.Provider value={{ collapsed, toggleCollapsed }}>
      {children}
    </ToolBarContext.Provider>
  );
};

export const useToolBar = () => {
  const context = useContext(ToolBarContext);
  if (!context) {
    throw new Error("useToolBar must be used within a ToolBarProvider");
  }
  return context;
};
